export default __webpack_public_path__ + "static/media/earth-background.9eb008c6.jpg";